module.exports = __webpack_public_path__ + "static/media/playground.dbbb3be9.ogg";